// Cliente HTTP da cobrança PIX avulsa (auth — usada pelo painel).
import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const pixCobrancaApi = {
  criar: (data) => axios.post(`${API}/payments/pix-online/cobranca`, data, { ...auth(), timeout: 30000 }),
  status: (txId) => axios.get(`${API}/payments/pix-online/cobranca/${txId}`, { ...auth(), timeout: 10000 }),
};
